import React, { useState, useEffect } from 'react';

const DeleteAccount = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const headerPadding = {
    paddingTop: isMobile ? '80px' : '3rem',
    paddingBottom: '3rem'
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('Account Deletion Request');
    const body = encodeURIComponent(
      `Account Deletion Request\n\nEmail: ${email}\nReason: ${reason || 'No reason provided'}`
    );
    window.location.href = `mailto:admin@ebarangay.ph?subject=${subject}&body=${body}`;
  };

  return (
    <>
      {/* Page Header */}
      <section className="section bg-theme-dark tc-light">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="page-header" style={headerPadding}>
                <h1 className="title title-xl">Delete Account</h1>
                <p className="lead">
                  Request the deletion of your EBARANGAY account and associated data.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="section bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div className="section-head text-center wide-auto-sm">
                <h2 className="title title-s4" title="Delete">Account Deletion</h2>
                <p>
                  We're sorry to see you go. Please read the following information before submitting your request.
                </p>
              </div>

              <div className="nk-block">
                <ul className="list list-dot">
                  <li>Your account and all associated personal data will be permanently deleted within 30 days of your request.</li>
                  <li>This includes your profile information, service requests, and any other data linked to your account.</li>
                  <li>Once deleted, your data cannot be recovered.</li>
                  <li>Any pending service requests will be cancelled upon account deletion.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Deletion Request Form */}
      <section className="section bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div className="section-head text-center wide-auto-sm">
                <h2 className="title title-s4" title="Request">Submit Deletion Request</h2>
                <p>
                  Enter your email address below and click submit. This will open your email client with a pre-filled message to our admin team.
                </p>
              </div>

              <div className="contact-wrap p-0">
                <form onSubmit={handleSubmit} className="contact-form nk-form">
                  <div className="field-item field-item-center">
                    <input
                      name="email"
                      type="email"
                      className="input-line input-line-center required"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <label className="field-label field-label-line">Your Email Address</label>
                  </div>
                  <div className="field-item field-item-center">
                    <textarea
                      name="reason"
                      className="input-line input-line-center input-textarea"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    ></textarea>
                    <label className="field-label field-label-line">Reason for Deletion (Optional)</label>
                  </div>
                  <div className="field-wrap text-center">
                    <button type="submit" className="btn btn-round btn-lg btn-grad">
                      Submit Deletion Request
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteAccount;
